import RelatedLinksNPM from '@rotaryintl/harris-related-links';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

const RelatedLinks = ({ params: { ComponentId } = {}, fields: { Title, Description, children: RelatedLinks } = {} }) => (
  <RelatedLinksNPM
    id={ComponentId}
    title={<Text field={Title} />}
    description={<Text field={Description} />}
    links={RelatedLinks?.map(({ fields: { Link, LinkText, ShowExternalLinkIcon } = {} }) => ({
      children: LinkText?.value,
      href: Link?.value?.href,
      target: Link?.value?.target || '_self',
      withIcon: ShowExternalLinkIcon?.value ?? false,
    }))}
  />
);

export default withSitecoreContext()(RelatedLinks);